var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerifiedSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "new_releases-24px (1)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "List/Creator",
    transform: "translate(-92.000000, -157.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(20.000000, 153.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "new_releases-24px-(1)",
    transform: "translate(72.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "none",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.815,8.46861945 L15.42,6.87861945 L15.615,4.77111945 C15.6525,4.39611945 15.3975,4.05111945 15.0375,3.96861945 L12.9675,3.49611945 L11.8875,1.67361945 C11.6925,1.35111945 11.295,1.21611945 10.95,1.36611945 L9,2.21361945 L7.0575,1.38111945 C6.7125,1.23111945 6.3075,1.36611945 6.12,1.68861945 L5.0325,3.50361945 L2.97,3.96861945 C2.6025,4.05111945 2.3475,4.38861945 2.385,4.77111945 L2.58,6.87111945 L1.185,8.46861945 C0.9375,8.75361945 0.9375,9.17361945 1.185,9.45861945 L2.58,11.0486194 L2.385,13.1636194 C2.3475,13.5386194 2.6025,13.8836194 2.9625,13.9661194 L5.0325,14.4386194 L6.1125,16.2536194 C6.3075,16.5761194 6.705,16.7111194 7.0575,16.5611194 L9,15.7136194 L10.9425,16.5461194 C11.2875,16.6961194 11.6925,16.5611194 11.88,16.2386194 L12.96,14.4161194 L15.03,13.9436194 C15.3975,13.8611194 15.645,13.5161194 15.6075,13.1411194 L15.4125,11.0336194 L16.8075,9.44361945 C17.0625,9.17361945 17.0625,8.75361945 16.815,8.46861945 L16.815,8.46861945 Z M8.35125,11.716875 C8.05875,12.009375 7.58625,12.009375 7.29375,11.716875 L5.71875,10.149375 C5.42625,9.856875 5.42625,9.384375 5.71875,9.091875 C6.01125,8.799375 6.48375,8.799375 6.77625,9.091875 L7.81875,10.134375 L11.17875,6.774375 C11.47125,6.481875 11.94375,6.481875 12.23625,6.774375 C12.52875,7.066875 12.52875,7.539375 12.23625,7.831875 L8.35125,11.716875 Z",
    id: "Shape",
    fillRule: "nonzero"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedSvg);
export default __webpack_public_path__ + "static/media/VerifiedSvg.42f5fd18f3db627d916f8ad39ab2b023.svg";
export { ForwardRef as ReactComponent };